






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {StatusSms} from '@/model/resource/StatusSms'
import {InputStatusSmsSchema} from '@/schema/resource/StatusSms/InputStatusSmsSchema'

@Component
export default class PersistStatusSmsView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputStatusSmsSchema()
  statusSms = new StatusSms()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.statusSms.getStatusSms(id)
    }

    $.await.done('getStatusSms')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.statusSms.persistStatusSms()
    await Helper.successAndPush('system.success.persist', '/status-sms/list')
  }
}
